export default __webpack_public_path__ + "static/media/WBBL_Logo.78821cc7.png";